import api from "../../../lib/api";
import masterApi from "../../../lib/masterApi";

export const merchantAuth = {
  current: options => options ? api.get("/auth/me", options) : api.get("/auth/me"),
  login: (email, password) => api.post("/auth/login", { email, password }),
  registerCustomer: payload => api.post("/auth/register-customer", payload),
};

export const masterAuth = {
  current: () => masterApi.get("/auth/me"),
  login: (email, password) => masterApi.post("/auth/login", { email, password }),
};
